import { render, staticRenderFns } from "./floatMenu.vue?vue&type=template&id=8b978b28&scoped=true"
import script from "./floatMenu.vue?vue&type=script&lang=js"
export * from "./floatMenu.vue?vue&type=script&lang=js"
import style0 from "./floatMenu.vue?vue&type=style&index=0&id=8b978b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b978b28",
  null
  
)

export default component.exports